import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientTimelineEditor() {
  return (
    <GenericAdminCRUD
      title="Linhas do Tempo — Campanhas"
      subtitle="Marcos padrão da jornada: Visita à área, Briefing, Branding, Estratégia, Check-list, Planilha de Custos, Enxoval, Planos de Mídia, Cotações. Marque quais exigem aprovação do cliente."
      path="client-timeline"
      fields={[
        { key: "campaign_id", label: "Campanha *", type: "campaignSelect" },
        { key: "title", label: "Título do evento *", type: "text" },
        { key: "date", label: "Data", type: "date" },
        { key: "requires_approval", label: "Exige aprovação do cliente?", type: "boolean" },
        { key: "order", label: "Ordem (menor = mais cedo)", type: "number" },
        { key: "description", label: "Descrição", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "title", label: "Evento" },
        { key: "date", label: "Data" },
        { key: "campaign_id", label: "Campanha", render: (it, { campaigns }) => campaigns.find((c) => c.id === it.campaign_id)?.name || "—" },
        { key: "requires_approval", label: "Aprovação", render: (it) => it.requires_approval ? "Sim" : "Não" },
        { key: "approval_status", label: "Status" },
      ]}
    />
  );
}
